<template>
  <div style="padding:15px" class="containerTable">
    <vxe-toolbar
      id="toolbarId_sy92"
      :custom="{storage: true}"
      export
      :refresh="{query: RefreshList}"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('partyGroup_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <!-- <el-button
          v-if="getLimit('partyGroup_add_button')"
          @click="funcAdd"
        >
          新增
        </el-button> -->
        <el-button
          v-if="getLimit('partyGroup_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="groupName"
          title="公司名称"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.groupName"
            placeholder="请输入公司名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="balance"
          title="账户余额"
          min-width="240"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.balanceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.balanceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="chargeTime"
          min-width="580"
          title="最新充值日期"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.chargeTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'chargeTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="chargeRemark"
          title="备注"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.chargeRemark"
            placeholder="请输入备注"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column
        
        title="操作"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('partyGroup_edit_button')"
            class="item"
            effect="dark"
            content="充值"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcEdit(scope.row.code)"
            >
              <i class="el-icon-setting" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('partyGroup_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDetail(scope.row.code,scope.row.balance)"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <!--<el-tooltip class="item" effect="dark" content="删除" placement="top">
                        <vxe-button type="text" @click="funcDelete(scope.row.code)">
                            <i class="el-icon-delete" />
                        </vxe-button>
          </el-tooltip>-->
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="500"
      height="300"
      resize
    >
      <compEdit
        ref="editRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="1200"
      resize
    >
      <compDetail ref="detailRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compEdit from "./components/partyGroupEdit.vue";
import compDetail from "./components/partyGroupDetail.vue";
import request from "@/utils/request";
export default {
  name: "PartyGroupList",
  components: {
    compEdit,
    compDetail
  },
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      modelDetailFlag: false,
      copy: false,
      exportObj:{
        exportUrl:"/ntocc-basic-api/partyGroup/exportPartyGroupDepositList",//导出接口
        name:'机构充值'
      },
      listQuery: {
        chargeTimeRange:'',
        code: "",
        parentCode: "",
        level: "",
        groupName: "",
        groupNameLocal: "",
        identity: "",
        address: "",
        wwwUrl: "",
        telephone: "",
        colorStyle: "",
        softVersion: "",
        misUrl: "",
        logoUrl: "",
        loginLogoUrl: "",
        uniformSocialCreditCode: "",
        uniformSocialCreditCodeUrl: "",
        organizationCode: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-basic-api/partyGroup",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 添加方法
    funcAdd() {
      this.modelAddFlag = true;
    },
    // 修改方法
    funcEdit(code) {
      this.$refs.editRef.init(code);
      this.modelEditFlag = true;
    },
    // 详情方法
    funcDetail(code, balance) {
      this.$refs.detailRef.getInfo(code, balance);
      this.modelDetailFlag = true;
    },
    // 删除方法
    funcDelete(row) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          request({
            url: `/ntocc-basic-api/partyGroup`,
            method: "delete",
            params: { codes: row }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    // 底部颜色设置
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      if (columnIndex === 0) {
        if ($rowIndex === 0) {
          return "col-blue";
        } else {
          return "col-red";
        }
      }
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    }
  }
};
</script>
